import React from 'react'
import { observer } from 'mobx-react'

const UnsupportedBrowser = () => (
  <div className='unsupported-browser'>
    <h3>Population Explorer is not supported on this browser. The following browsers are supported:</h3>
    <ul>
      <li>Up-to-date versions of Chrome, Firefox, and Edge</li>
      <li>Internet Explorer 11</li>
      <li>Safari 10+</li>
    </ul>
    <p>Questions? Contact us at <a href='support@forestwalk.com'>support@forestwalk.com</a></p>
  </div>
)

export default observer(UnsupportedBrowser)
